var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 1.70829V0.922509C8.77694 0.918571 8.88803 0.916626 8.99984 0.916626C14.0162 0.916626 18.0832 4.9836 18.0832 9.99996C18.0832 10.1118 18.0812 10.2229 18.0773 10.3333H17.2923H16.8396L16.7948 10.7839C16.4016 14.7415 13.0611 17.8333 8.99984 17.8333C4.67348 17.8333 1.1665 14.3263 1.1665 9.99996C1.1665 5.93868 4.25828 2.59824 8.21584 2.20585L8.6665 2.16117V1.70829ZM15.6148 10.3333H8.6665V3.38496V2.81731L8.10339 2.88896C6.29625 3.1189 4.64448 4.02833 3.48379 5.4324C2.3231 6.83647 1.74059 8.62983 1.85467 10.448C1.96874 12.2661 2.77084 13.9726 4.09793 15.2206C5.42502 16.4685 7.17751 17.1644 8.99922 17.1666H8.99985C10.7455 17.1666 12.4311 16.5295 13.7403 15.375C15.0496 14.2204 15.8925 12.6277 16.1109 10.8958L16.1818 10.3333H15.6148ZM16.8732 9.66663H17.429L17.3704 9.1139C17.1673 7.1984 16.3135 5.41046 14.9514 4.0484C13.5893 2.68633 11.8014 1.83252 9.88589 1.62941L9.33317 1.57081V2.12663V9.16663V9.66663H9.83317H16.8732Z",
    fill: "black",
    stroke: "#1B407A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.b65939e3285063142d75a136713d380c.svg";
export { ForwardRef as ReactComponent };